﻿$.fn.dxCtrlBcLstDossier = function custom_dxCtrlBcLstDossier(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbclstdossier dx-ctrl");
        this.createInstance(new cdxCtrlBcLstDossier(this, option));
    }
    return this;
}

window.cdxCtrlBcLstDossier = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        $("<div/>").appendTo(container).dxDropDownBox({
            labelMode: option.labelMode,
            label: option.label,
            valueExpr: 'id_bc_dossier',
            displayExpr: 'objet',
            value: option.value,
            placeholder: 'Sélectionner un dossier...',
            showClearButton: true,
            inputAttr: { 'aria-label': 'Owner' },
            dataSource: new DevExpress.data.CustomStore({
                loadMode: 'raw',
                key: 'ID',
                load() {
                    return option.bddCtrl.mGetArray("bc_dossier");
                },
            }),
            onValueChanged: function (e) {
                e.component.close()
                option.value = e.value
                option.onValueChanged(option.value)
            },
            contentTemplate(e) {
                var $DivTreeView = $('<div>').dxTreeView({
                    dataSource: e.component.getDataSource(),
                    dataStructure: 'plain',
                    keyExpr: 'id_bc_dossier',
                    parentIdExpr: 'id_bc_dossier_parent',
                    selectionMode: 'single',
                    displayExpr: 'objet',
                    selectByClick: true,
                    onContentReady(args) {
                        $treeView = args.component
                        if (typeof e.component.option('value') == "undefined" || e.component.option('value') == null) {
                            args.component.unselectAll();
                        } else {
                            args.component.selectItem(e.component.option('value'));
                        }
                        //const value = e.component.option('value');
                        //mChange(args.component, value);
                    },
                    selectNodesRecursive: false,
                    onItemSelectionChanged(args) {
                        if (args.component.getSelectedNodeKeys().length > 0) {
                            const selectedKeys = args.component.getSelectedNodeKeys();
                            e.component.option('value', selectedKeys[0]);
                        }
                    },
                })

                ////e.component.on('valueChanged', (args) => {
                ////    mChange(args.value)
                ////    e.component.close();
                ////});

                //function mChange(value) {
                //    if (!value) {
                //        $treeView.unselectAll();
                //        option.value = null
                //    } else {
                //        $treeView.selectItem(value);
                //        option.value = value[0]
                //    }
                //    e.component.option("value",option.value)
                //}

                return $DivTreeView;
            },
        }).dxDropDownBox("instance")
    }

    function makeAsyncDataSource(jsonFile) {
        return new DevExpress.data.CustomStore({
            loadMode: 'raw',
            key: 'ID',
            load() {
                return $.getJSON(`data/${jsonFile}`);
            },
        });
    };

    this.element = function () { return container; }

    mConstruit();
}